export class AuthLogin {
  static readonly type = '[Auth] Login';

  constructor(public email: string, public password: string) {
  }
}

export class AuthRefresh {
  static readonly type = '[Auth] Refresh';

  constructor(public token: string) {
  }
}

export class AuthLogout {
  static readonly type = '[Auth] Logout';

  constructor() {
  }
}
